import { createContext, useContext } from "react"
import type { ICommune } from "@/types/explore"

export const CommuneContext = createContext<ICommune | undefined>(undefined)

export const useCommune = () => useContext(CommuneContext)
